export default {
  ERROR: '/identity/signup/error',
  LINK: '/link',
  LINK_EXISTING_ACCOUNT: '/link/existing-account',
  LITE: '/lite',
  RUSSIAN_TERMS: '/terms-ru',
  SESSION_EXPIRED: '/identity/signup/session-expired',
}
